module.exports = __webpack_public_path__ + "img/slots.a86bfccc.png";